import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { TrendingUp, TrendingDown } from 'lucide-react';
import { formatInsightCurrency, formatInsightPercent } from '../hooks/usePortfolioInsights';

const PerformerCard = ({ performer, isTop }) => {
  if (!performer) return null;
  if (!isTop && performer.current_value >= performer.amount) return null;
  const returnPct = ((performer.current_value - performer.amount) / performer.amount) * 100;
  const Icon = isTop ? TrendingUp : TrendingDown;
  const color = isTop ? 'green' : 'red';

  return (
    <Card className={`border-${color}-200 bg-${color}-50/50`}>
      <CardHeader className="pb-3">
        <CardTitle className="text-base flex items-center space-x-2"><Icon className={`w-4 h-4 text-${color}-600`} /><span>{isTop ? 'Top Performer' : 'Needs Attention'}</span></CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-2">
          <div className="flex justify-between items-start">
            <div><p className="font-semibold text-slate-900">{performer.name}</p><Badge variant="outline" className="mt-1 text-xs">{performer.type.replace('_', ' ')}</Badge></div>
            <div className="text-right">
              <p className={`text-lg font-bold text-${color}-600`}>{formatInsightPercent(returnPct)}</p>
              <p className="text-sm text-slate-500">{formatInsightCurrency(performer.current_value - performer.amount, performer.currency)}</p>
            </div>
          </div>
          <div className="flex justify-between text-xs text-slate-500 pt-2 border-t">
            <span>Invested: {formatInsightCurrency(performer.amount, performer.currency)}</span>
            <span>Current: {formatInsightCurrency(performer.current_value, performer.currency)}</span>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export const PerformerCards = ({ topPerformer, worstPerformer }) => (
  <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
    <PerformerCard performer={topPerformer} isTop />
    <PerformerCard performer={worstPerformer} isTop={false} />
  </div>
);
